module.exports = __webpack_public_path__ + "img/Placeholder_image.d893ba4a.jpg";